/* eslint-disable */
// import 'promise-polyfill/src/polyfill'
// import 'babel-polyfill'
import './assets/getcomputedstylepfill'
import './assets/btoappfill'
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import {store as storeConfig} from './store'
import vuescroll from 'vue-scroll'
import VueCookie from 'vue-cookie'

if (!global._babelPolyfill) {
  try {
    if (!window.Promise) {
      console.log('-- 1 polyfilling')
      require('../node_modules/core-js/es6/promise')
      require('../node_modules/core-js/es6/object')
      // require('promise-polyfill/src/polyfill')
      //require('babel-polyfill')
    } else {
      console.log('@@ 2 no polyfilling')
    }
  } catch (e) {
    console.log('@@ 3 no polyfilling', e)
  }
} else {
  console.log('@@ 4 no polyfilling')
  global._babelPolyfill = false
}
Vue.use(vuescroll)
Vue.use(Vuex)
Vue.use(VueCookie)

Vue.config.productionTip = false
const store = new Vuex.Store(storeConfig)
store.dispatch('init')
store.dispatch('load')
  .then(() => {
    /* eslint-disable no-new */
    const appDiv = document.getElementById('mm-prv-wdg')
    const formDiv = document.getElementsByClassName('mm-prv-form')[0]
    const newDiv = document.createElement('div')
    newDiv.innerHTML = appDiv.innerHTML
    newDiv.style.display = 'none'
    formDiv.appendChild(newDiv)

    console.log('--- v 1.0.3 ieMode')
    window.mmprvapp = new Vue({
      el: '#mm-prv-wdg',
      components: { App },
      template: '<App/>',
      store,
      data: {
        ver: '1.0.2'
      }
    })

  })
  .catch((e) => console.log(e))



// WEBPACK FOOTER //
// ./src/main.js